import Header from "../Header";
import Banner from "../Banner";
import Footer from "../Footer";
import GlobalMenu from "../GlobalMenu";
import NationalRace from "./national/NationalRace";
import TaleOfTheTape from "./national/TaleOfTheTape";
import LocalRace from "./local/LocalRace";
import ProvincialCityPage from "./local/province/ProvincialCityPage";
import styles from "../../styles/homepage/Home.module.scss";

const RacesPage = ({
  view = "default",
  national = true,
  path,
  presidential,
  vPresidential,
  senatorialList,
  partyList,
  partyListMain,
  allPartyList,
  regionList,
  cityList,
  provincesList,
  philippines,
  info,
  taguigLoneDistrict,
  provincialCities,
  contests,
  url,
  locationViceData = [],
  locationPresData = [],
}) => {
  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu />
      {national ? (
        path !== "tale-of-the-tape" ? (
          <NationalRace
            view={view}
            path={path}
            presidential={presidential}
            vPresidential={vPresidential}
            senatorialList={senatorialList}
            regionList={regionList?.results}
            provincesList={provincesList?.results}
            cityList={cityList?.cities}
            partyList={partyList}
            partyListMain={partyListMain}
            allPartyList={allPartyList}
            philippines={philippines}
            url={url}
            locationViceData={locationViceData}
            locationPresData={locationPresData}
          />
        ) : (
          <TaleOfTheTape
            presidential={presidential}
            vPresidential={vPresidential}
          />
        )
      ) : info?.id ? (
        <ProvincialCityPage
          path={path}
          view={view}
          url={url}
          info={info}
          taguigLoneDistrict={taguigLoneDistrict}
          provincialCities={provincialCities}
          contests={contests}
          presidential={presidential}
          vPresidential={vPresidential}
          senatorialList={senatorialList}
          partyList={partyList}
          allPartyList={allPartyList}
          regionList={regionList}
        />
      ) : (
        <LocalRace
          path={path}
          cityList={cityList?.cities}
          provincesList={provincesList?.results}
          regionList={regionList}
        />
      )}
      <Footer />
    </div>
  );
};

export default RacesPage;
